export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    showHeader() {
      return this.items.length > 1;
    },
    bannerLevel() {
      return this.items.length && this.items.every((item) => item.level === 'warning')
        ? 'warning'
        : 'success';
    },
    bannerLevelClass() {
      return `deposit-promotions-banner--${this.bannerLevel}`;
    },
  },
  methods: {
    itemClass(item) {
      return {
        [`deposit-promotions-banner__item--${item.level || 'success'}`]: true,
        'deposit-promotions-banner__item--single': !this.showHeader,
      };
    },
  },
};
